import React from "react";
import { ApolloProvider } from "@apollo/client";
import { HttpLink, InMemoryCache, ApolloClient } from "@apollo/client/core";
import { ErrorResponse, createPersistedQueryLink } from "@apollo/client/link/persisted-queries";
import { sha256 } from "crypto-hash";

import {getHomepageContent, preloadQuery} from "@/cms/templates/Homepage/misc/queries";

//import "../../cms/global.scss";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customFetch = (uri : any, options : any) => {
  if (options && options.method === "GET") {
    // make sure we issue simple get request to prevent CORS pre flight
    options.headers = {};
  }
  //{"method":"GET","headers":{"accept":"*/*","content-type":"application/json"},"signal":{}}
  return fetch(uri, options);
};

/* Apollo Client Instantiation */
const httpLink = new HttpLink({ uri: process.env.CMS_SERVER_URL, fetch: customFetch });

const disablePersistedQueries = (op: ErrorResponse) => {
  if (op.response) {
    const asString = JSON.stringify(op.response);
    if (asString.includes("Persisted queries are not supported by this server")) {
      return true;
    }
  }
  return false;
};

const isDebugModeOn = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get("wp_gql_debug") !== "on";
};

const persistedQueriesLink = createPersistedQueryLink({
  useGETForHashedQueries: isDebugModeOn(),
  sha256,
  disable: disablePersistedQueries,
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: persistedQueriesLink.concat(httpLink),
});

interface Props {
  component: JSX.Element;
}

const ApolloWrapper = ({ component }: Props): React.ReactElement => {
  return <ApolloProvider client={client}>{component}</ApolloProvider>;
};



export function preloadHomepageContent() {

  if(window.location.pathname === '/'){
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return client.query({
      query: getHomepageContent("new-homepage-showcase")
    })
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return client.query({
      query: preloadQuery("new-homepage-showcase")
    })
  }

}

export default ApolloWrapper;
